import { render, staticRenderFns } from "./Leitura.vue?vue&type=template&id=8f7199c2&scoped=true"
import script from "./Leitura.vue?vue&type=script&lang=js"
export * from "./Leitura.vue?vue&type=script&lang=js"
import style0 from "./Leitura.vue?vue&type=style&index=0&id=8f7199c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7199c2",
  null
  
)

export default component.exports